export default __webpack_public_path__ + "static/proxima-nova-800-a6a9a847fd0db78ac76f5f7788ef9336.woff";